import { truncateByDevice } from "@components/mediaQuery/truncateByDevice";
import { useIsDesktop, useIsMobile, useIsTablet } from "@components/mediaQuery/useIsMobile";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Don't forget this if using navigate

const ModulesHeader = ({
	subModuleTitle = "",
	isNotVessel = true,
	isVessel = false,
	kitdevice = "",
	vesselsite = "",
	isKit = false,
	isPresent = false,
}) => {
	const navigate = useNavigate();

	const isMobile = useIsMobile();

	const isTablet = useIsTablet();
	const isDesktop = useIsDesktop();
	const selectedVessel = useSelector((state) => state.modules.vessels.selectedVessel);

	const selectedDevice = useSelector((state) => state.modules.vessels.activation.selectedKit);
	const handleNavigateBack = () => {
		const backSteps = window.location.href.includes("") ? -2 : -1;
		navigate(backSteps);
	};

	const handleNavigateVesselBack = async () => {
		const backSteps = window.location.href.includes("#") ? -2 : -1;
		navigate(backSteps);
	};

	return (
		<div className="flex justify-start space-x-1 space-y-1 px-2 pt-2.5 pb-2.5">
			{/* {!isVessel && (
				<button
					type="button"
					onClick={handleNavigateBack}
					className="flex w-auto min-w-[40px] items-center rounded-lg bg-dark-blue bg-opacity-80 p-2 font-medium text-white text-xs hover:bg-opacity-40 focus:outline-none focus:ring-2 focus:ring-blue-gray"
				>
					<img src="/src/assets/icons/arrow-left.svg" alt="Back" className="h-4 w-4" />
				</button>
			)} */}
			{isVessel && (
				<button
					type="button"
					onClick={handleNavigateVesselBack}
					className="flex w-auto min-w-[40px] items-center rounded-lg bg-dark-blue bg-opacity-80 p-2 font-medium text-white text-xs hover:bg-opacity-40 focus:outline-none focus:ring-2 focus:ring-blue-gray"
				>
					<img src="/src/assets/icons/arrow-left.svg" alt="Back" className="h-4 w-4" />
				</button>
			)}
			<span className="self-center whitespace-nowrap font-light text-blue-gray text-md sm:text-sm md:text-lg xl:text-xl 2xl:text-2xl">
				{subModuleTitle}
			</span>

			{isKit ? (
				<>
					<span className="mx-[8px] text-white">–</span>
					<span
						title={kitdevice}
						className="mx-[3px] self-center whitespace-nowrap font-light text-[12px] text-white sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-xl 2xl:text-2xl"
					>
						{truncateByDevice(kitdevice, isMobile, isTablet, isDesktop)}
					</span>
				</>
			) : (
				<>
					{isPresent && <span className="mx-[8px] text-white">–</span>}
					<span
						title={vesselsite}
						className="mx-[3px] self-center whitespace-nowrap font-light text-[12px] text-white sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-xl 2xl:text-2xl"
					>
						{truncateByDevice(vesselsite, isMobile, isTablet, isDesktop)}
					</span>
				</>
			)}
		</div>
	);
};

export default ModulesHeader;
